import { ComponentProps, ReactNode, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './Text.module.css';

type TextTag =
  | 'span'
  | 'p'
  | 'h6'
  | 'h5'
  | 'h4'
  | 'h3'
  | 'h2'
  | 'h1'
  | 'strong'
  | 'small'
  | 'em';

export type TextProps = ComponentProps<TextTag> & {
  children: ReactNode;
  as?: TextTag;
  weight?: 'reg' | 'med' | 'bold';
  size?: 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
  applyDefaultMargin?: boolean;
  className?: string;
};

export const Text = forwardRef<
  HTMLHeadingElement | HTMLParagraphElement,
  TextProps
>(
  (
    {
      children,
      as: Tag = 'p',
      weight = 'med',
      size = 'm',
      applyDefaultMargin = true,
      className,
    }: TextProps,
    ref,
  ) => {
    return (
      <Tag
        ref={ref}
        className={classNames({ [styles.noMargin]: !applyDefaultMargin }, [
          styles[`weight-${weight}`],
          styles[`size-${size}`],
          className,
        ])}
      >
        {children}
      </Tag>
    );
  },
);

Text.displayName = 'Text';
